import { PureComponent } from "react";
import { Form, type InjectedFormProps, type Validator, reduxForm } from "redux-form";

import { Dialog, TriggerButton, TriggerButtonIntent } from "widgets";

import { specialCharacterValidation } from "../../app-utils/form.js";
import { type IPopoverPropsInjectedFromController } from "../core/overlays/components/OverlayControllers.js";
import TextReduxFormField from "@/ui-modules/core/redux-form/TextField.tsx";

interface IAddVocabularyTermFormProps extends IPopoverPropsInjectedFromController {
  doesControlledValueExist: (term: string) => boolean;
  onAddTerm: (term: string) => void;
  maxTermLength: number;
}

interface IAddVocabularyTermFormAllProps extends IAddVocabularyTermFormProps, InjectedFormProps<any, any> {}

class AddVocabularyTermFormImpl extends PureComponent<IAddVocabularyTermFormAllProps> {
  public static ADD_TERM_DIALOG_FORM_NAME = "addVocabularyTerm";
  public static ADD_TERM_DIALOG_FIELD_TERM = "term";

  constructor(props: IAddVocabularyTermFormAllProps) {
    super(props);
  }

  handleSubmitData = (values): Promise<any> => {
    const term: string = values[AddVocabularyTermFormImpl.ADD_TERM_DIALOG_FIELD_TERM]?.trim();
    this.props.onAddTerm(term);
    this.props.reset();
    return Promise.resolve(true);
  };

  termValidation: Validator = (value: any, _allValues?: any, _props?: any) => {
    if (!value || value.trim().length === 0) {
      return `Your input is required.`;
    } else if (this.props.doesControlledValueExist(value)) {
      return `This term already exists.`;
    }
  };

  render() {
    return (
      <Dialog {...this.props} ref={this.props.dialogRef}>
        <Form onSubmit={this.props.handleSubmit(this.handleSubmitData)} style={{ minWidth: "200px", padding: 10 }}>
          <TextReduxFormField
            name={AddVocabularyTermFormImpl.ADD_TERM_DIALOG_FIELD_TERM}
            label={"New Vocabulary Term"}
            placeholder="Enter term"
            maxLength={this.props.maxTermLength}
            validate={[specialCharacterValidation, this.termValidation]}
            autoFocus={true}
            isRequired={true}
            action={
              <TriggerButton
                label={"Add"}
                icon={"add"}
                onPress={this.props.handleSubmit(this.handleSubmitData)}
                intent={TriggerButtonIntent.Active}
              />
            }
          />
        </Form>
      </Dialog>
    );
  }
}

const AddVocabularyTermForm = reduxForm({
  form: AddVocabularyTermFormImpl.ADD_TERM_DIALOG_FORM_NAME,
})(AddVocabularyTermFormImpl) as any;
export default AddVocabularyTermForm;
